export class Task {
  id: string
  title: string
  description: string
  category?: string | null
  additional_metadata?: string | null

  constructor({
    id,
    title,
    description,
    category = null,
    additional_metadata = null
  }: {
    id: string
    title: string
    description: string
    category?: string | null
    additional_metadata?: string | null
  }) {
    this.id = id
    this.title = title
    this.description = description
    this.category = category
    this.additional_metadata = additional_metadata
  }

  public generatePrompt(moreMetadata?: string): string {
    let prompt = `Title: ${this.title}\nCategory: ${this.category}\nDescription: ${this.description}`

    if (this.additional_metadata) {
      prompt += `\nAdditional Information (ensure you take this into account when generating the task):\n
${this.additional_metadata}`
    }

    if (moreMetadata) {
      prompt += `\nAdditional Information (ensure you take this into account when generating the task):\n
${moreMetadata}`
    }

    return prompt
  }
}
